import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { useNavigate } from "react-router-dom";

//
import { Button } from "react-bootstrap";

//
import { showPlanModal } from "../../../redux/features/plan/slice";
import {
  createInvoice,
  createProductInvoice,
} from "../../../redux/features/plan/actions";
import { getUser } from "../../../redux/features/user/actions";

function Payment({
  product = false,
  planModal,
  choosedPlan,
  getUser,
  showPlanModal,
  tradingviewUsername,
}) {
  let navigate = useNavigate();
  const [status, setStatus] = useState("pending");
  const [invoiceCode, setInvoiceCode] = useState("");

  /**
   * Back To Dashboard
   */
  const backToDashboard = () => {
    showPlanModal({ show: false, step: "choose-plan", type: "plan" });
    navigate("/app");
  };

  /**
   * Set Title For Every Status
   */
  const statusTitle = () => {
    if (status === "success")
      return "Thank you, for purchasing your subscription 🎉";

    if (status === "failed")
      return "Your transaction is failed, seems something wrong";

    return "Wait for a while, your transaction is pending";
  };

  /**
   * Send Pay Request
   */
  const send_pay_request = async () => {
    // start loading
    setStatus("pending");

    // set variables
    let payType = planModal.method;
    let auto_renew = "active";
    let product_id = choosedPlan.id;
    let token = planModal.token;

    let content = {
      product_id,
    };
    if (!product) {
      content.auto_renew = auto_renew;
    } else {
      content.username = tradingviewUsername;
    }

    if (payType === "stripe") {
      content.token = token;
    }

    if (choosedPlan.discountCode) {
      content.coupon = choosedPlan.discountCode;
    }

    // request
    if (!product) {
      createInvoice({ payType, content }).then((res) => {
        if (res) {
          setInvoiceCode(res);

          setStatus("success");

          getUser();
        } else {
          setStatus("failed");
        }
      });
    } else {
      createProductInvoice({ payType, content }).then((res) => {
        if (res) {
          setInvoiceCode(res);

          setStatus("success");

          getUser();
        } else {
          setStatus("failed");
        }
      });
    }
  };

  useEffect(() => {
    send_pay_request();

    // eslint-disable-next-line
  }, []);

  return (
    <div className="status">
      <img
        src={process.env.PUBLIC_URL + `/payment-icons/${status}.png`}
        alt={status}
      />
      <h5>{statusTitle()}</h5>
      <div className="decription">
        <p>We will send payment receipt to your email shortly.</p>
        <p>Hope you enjoy premium experience.</p>
      </div>

      {status === "failed" ? (
        <Button variant="info" size="lg" onClick={() => send_pay_request()}>
          Try again
        </Button>
      ) : (
        <Button variant="info" size="lg" onClick={() => backToDashboard()}>
          Go to dashboard
        </Button>
      )}

      {status === "success" && (
        <div className="recipe">
          <div className="code">
            <span>
              <span>
                <i className="las la-check"></i>
              </span>
            </span>
            <div>
              <p className="fw-extra-bolder">Payment Complete</p>
              <p>#{invoiceCode}</p>
            </div>
          </div>

          <div className="theme">
            <div className="item">
              <div className="left">
                <span className="long dark"></span>
                <div>
                  <span className="medium light"></span>
                  <span className="long light"></span>
                </div>
              </div>

              <span className="medium light"></span>
            </div>

            <div className="item">
              <div className="left">
                <span className="short dark"></span>
                <div>
                  <span className="long light"></span>
                  <span className="short light"></span>
                </div>
              </div>

              <span className="medium light"></span>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

Payment.propTypes = {
  tradingviewUsername: PropTypes.string.isRequired,
  planModal: PropTypes.object.isRequired,
  choosedPlan: PropTypes.object.isRequired,
  getUser: PropTypes.func.isRequired,
  showPlanModal: PropTypes.func.isRequired,
};

const mapDispatchToProps = {
  getUser,
  showPlanModal,
};

const mapStateToProps = (state) => ({
  planModal: state.planReducer.planModal,
  choosedPlan: state.planReducer.choosedPlan,
  tradingviewUsername: state.planReducer.tradingviewUsername,
});

export default connect(mapStateToProps, mapDispatchToProps)(Payment);
